import React from "react"
import Calendar from "../Calendar/Calendar"


export default function Home() {
  return (
    <div>
      <div
        style={{
          padding: "20px",
          borderRadius: "5px",
          marginBottom: "20px",
          textAlign: "left",
          fontSize: "18px",
          fontFamily: "Arial, Helvetica, sans-serif",
          maxWidth: "50%",
          margin: "0 auto",
        }}
      >
Great news! First-time Members to The Broadway Maven can get <strong>30 days FREE</strong>  at the link below. Normally $18, a one-month Membership comes with invitations to 5-15 classes and other expert-led Broadway experiences. Cancel at any time, or continue exploring Broadway with this vibrant educational community. It’s your home for Broadway appreciation.
      </div>

      <a
        href="https://thebroadwaymaven.substack.com/subscribe?coupon=b0a7a398"
        target="_blank"
        rel="noreferrer"
        style={{
          display: "block",
          fontSize: "24px",
          textDecoration: "underline",
          hover: "hand",
          color: "#7756e3",
          textAlign: "center",
          marginBottom: "20px",
        }}
      >
        Get a month FREE!
      </a>
      {/* <Link to="/all-access">
        <div
          style={{
            fontSize: "24px",
            textDecoration: "underline",
            hover: "hand",
            color: "#7756e3",
          }}
        >
          Broadway Maven ALL-ACCESS Pass
        </div>
      </Link> */}

      <br />
      <div
        style={{
          padding: "20px",
          borderRadius: "5px",
          marginBottom: "20px",
          textAlign: "left",
          fontSize: "18px",
          fontFamily: "Arial, Helvetica, sans-serif",
          maxWidth: "50%",
          margin: "0 auto",
        }}
      >
The Broadway Maven Student Seminar is <strong>now accepting applications</strong> for a scholarship program aimed at full-time students ages 16-26. Successful participants will receive a $500 stipend, a certificate of achievement, and four invitations to Broadway shows at The Hayes Theatre. The online program, which meets every Sunday in May and June 2025, emphasizes the history of Broadway, with the goal of helping students think more deeply about musical theater. Students can apply at the link below.
      </div>
      <a
        href="https://www.eventbrite.com/e/500-paid-scholarship-for-broadway-loving-students-ages-16-26-tickets-1285774569349?aff=oddtdtcreator"
        target="_blank"
        rel="noreferrer"
        style={{
          display: "block",
          fontSize: "24px",
          textDecoration: "underline",
          hover: "hand",
          color: "#7756e3",
          textAlign: "center",
          marginBottom: "20px",
        }}
      >
        Apply for the Broadway Maven Scholars Program
      </a>
      {/* <Link to="/studentseminar">
        <div
          style={{
            fontSize: "24px",
            textDecoration: "underline",
            hover: "hand",
            color: "#7756e3",
             display: "flex", justifyContent: "center"
          }}
        >
          Apply for the Student Seminar
        </div>
      </Link> */}
      <br />

      <div style={{ display: "flex", justifyContent: "center" }}>
        <Calendar />
      </div>
      <br />
      <br />
      <div style={{ display: "flex", justifyContent: "center" }}>
        {" "}
        <iframe
          title="David Benkof Video"
          width="560"
          height="315"
          src="https://www.youtube.com/embed/YxaYYq3hJ64?si=Bjg1ZoVvGPg38JVi?autoplay=1"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowfullscreen
        ></iframe>
      </div>

      <br />

      <div
        style={{
          padding: "20px",
          borderRadius: "5px",
          marginBottom: "20px",
          textAlign: "left",
          fontSize: "18px",
          fontFamily: "Arial, Helvetica, sans-serif",
          maxWidth: "50%",
          margin: "0 auto",
        }}
      >
        The Broadway Maven is an educational community that helps its members
        think more deeply about musical theater. Every month, members may attend
        5-15 expert-led classes and innovative Broadway experiences, all for
        just $18. We also foster enthusiasm for Broadway through the FREE weekly
        substack newsletter{" "}

        <a
          href="https://thebroadwaymaven.substack.com/"
          target="_blank"
          rel="noreferrer"
          style={{ color: "#007bff", textDecoration: "none" }}
        >
          {" "}
          <em>MARQUEE</em>
        </a>{" "}
        and host an expansive{" "}
        <a
          href="https://www.youtube.com/c/DavidBenkofTheBroadwayMaven"
          target="_blank"
          rel="noreferrer"
          style={{ color: "#007bff", textDecoration: "none" }}
        >
          YouTube channel
        </a>
        . It's your home for Broadway appreciation.
      </div>
      <br />
    </div>
  )
}
